import AltLayout from 'Nori/Layout/AltLayout';
import Hero from 'Custom/Hero';
import Warnings from 'Custom/Warnings';
import RichText from 'Custom/RichText';
import Container from 'Nori/Container';
import Button from 'Nori/Button';
import SplitContent from 'Custom/Split/SplitContent';
import AjustableImage from 'Custom/AjustableImage';
import ConditionsTable from 'Custom/Table/ConditionsTable';
import { Table } from 'Custom/Table';
import { AlternativeTable } from 'Custom/Table/AlternativeTable';
import HeroFull from 'Nori/Hero/HeroFull';
import ItemBreakpoint from 'Custom/ItemBreakpoint';
import { SPANISH_JOB_CODE } from 'Custom/Footer/es/Footer.utils';

import {
  SE_TABLE_1,
  SE_TABLE_2,
  SE_TABLE_3,
  CONDITIONS_TABLE,
  WARNINGS_ITEMS_LIST,
  WARNINGS_TITLE,
} from 'Utils/es/side-effects';

import QUESTIONS_IMAGE from 'Images/misc/icon-question-desktop.webp';
import QUESTIONS_IMAGE_MOBILE from 'Images/misc/icon-question-mobile.webp';
import PLUS_IMAGE from 'Images/misc/plus-sign-desktop.webp';
import BLUE_BG from 'Images/background/blue-bg.png';
import BLUE_BG_MOBILE from 'Images/background/blue-bg-mobile.png';
import DARK_BLUE_BG from 'Images/misc/dark-blue-bg.png';
import DARK_BLUE_BG_MOBILE from 'Images/misc/dark-blue-bg-mobile.png';
import SIDE_EFFECTS_TABLE_BG from 'Images/background/side_effects_table.png';

import styles from 'styles/pages/sideEffects.module.scss';

const HEAD = {
  title:
    'Riesgos y efectos secundarios de NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  keywords: 'efectos secundarios de nexplanon',
  description:
    'Revise los posibles riesgos y efectos secundarios de NEXPLANON® (etonogestrel implant) 68 mg Radiopaque, incluidos los efectos secundarios más comunes y quiénes no deben usarlo.',
  hreflang: 'es-us',
};

const HERO_IMAGE = {
  src: PLUS_IMAGE,
  width: 403,
};

const HERO_IMAGE_MOBILE = {
  src: PLUS_IMAGE,
};

export default function SideEffectsSpanish() {
  return (
    <AltLayout head={HEAD} jobCode={SPANISH_JOB_CODE}>
      <div className={styles.esPage} data-qa-tag="es-page-side-effects">
      <Hero
        autoHeightOnMobile
        className={styles.customHero}
        backgroundImage={BLUE_BG.src}
        mobileBackgroundImage={BLUE_BG_MOBILE.src}
        variant="overlap"
        image={HERO_IMAGE}
        mobileImage={HERO_IMAGE_MOBILE}
        imageBreakpoint="xl"
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Hero"
        data-design-module_name="EFECTOS SECUNDARIOS DE NEXPLANON"
        data-design-module_no="01"
        data-qa-tag="hero-side-effects"
      >
        <RichText data-qa-tag="richtext-hero-side-effects">
          <h4 className={styles.heroBaseHeading} data-qa-tag="heading-hero-side-effects">
            Efectos secundarios y riesgos
          </h4>
          <h2 data-qa-tag="subheading-hero-side-effects">
            Conozca los efectos secundarios más frecuentes, los posibles
            riesgos de usar <span className={styles.h2Header}>NEXPLANON</span>,
            e información sobre quién no debe usar{' '}
            <span className={styles.h2Header}>NEXPLANON</span>
          </h2>
        </RichText>
      </Hero>

      <section className={styles.sectionCommonSideEffects} data-qa-tag="section-common-side-effects">
        <Container
          size="md"
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-nori_id="Inline Content"
          data-design-module_name="¿cuáles son los efectos secundarios más frecuentes de NEXPLANON?"
          data-design-module_no="02"
          data-qa-tag="container-common-side-effects"
        >
          <RichText className={styles.tableWrapper} data-qa-tag="richtext-common-side-effects">
            <h2 data-qa-tag="heading-common-side-effects">
              ¿Cuáles son los efectos secundarios más frecuentes de NEXPLANON?
            </h2>
            <Table
              className="compact"
              content={SE_TABLE_1}
              title="¿cuáles son los efectos secundarios más frecuentes de NEXPLANON?"
              data-qa-tag="table-se-1"
            />
          </RichText>
        </Container>
      </section>

      <Warnings
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name={WARNINGS_TITLE}
        data-design-module_no="03"
        title={WARNINGS_TITLE}
        itemsList={WARNINGS_ITEMS_LIST}
        data-qa-tag="warnings-side-effects"
      />

      <ConditionsTable
        showIcon={false}
        {...CONDITIONS_TABLE}
        className={styles.conditionsTableOverrides}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="Infórmele a su médico si usted tiene o ha tenido estas afecciones"
        data-design-module_no="04"
        data-qa-tag="conditions-table-side-effects"
      >
        <RichText data-qa-tag="richtext-conditions-table">
          <h2 className="mb" data-qa-tag="heading-conditions-table">
            Infórmele a su médico si usted tiene o ha tenido estas afecciones
          </h2>
          <p className="intro" data-qa-tag="intro-conditions-table">
            Su médico puede sugerirle un método anticonceptivo diferente.
          </p>
        </RichText>
      </ConditionsTable>

      <div
        className={styles.tableBg}
        style={{ backgroundImage: `url(${SIDE_EFFECTS_TABLE_BG.src})` }}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="Estos son otros riesgos posibles de NEXPLANON:"
        data-design-module_no="05"
        data-qa-tag="table-bg-risks"
      >
        <Container size="md" data-qa-tag="container-risks">
          <RichText className={styles.tableWrapper} data-qa-tag="richtext-risks">
            <h2 data-qa-tag="heading-risks">Estos son otros riesgos posibles de NEXPLANON:</h2>
            <Table
              className="compact"
              content={SE_TABLE_2}
              title="Estos son otros riesgos posibles de NEXPLANON:"
              data-qa-tag="table-se-2"
            />
          </RichText>
        </Container>
      </div>

      <section className={styles.sectionCallYourDoctor} data-qa-tag="section-call-doctor">
        <Container
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-nori_id="Inline Content"
          data-design-module_name="llame de inmediato al médico si usted tiene:"
          data-design-module_no="06"
          data-qa-tag="container-call-doctor"
        >
          <RichText className={styles.tableWrapper} data-qa-tag="richtext-call-doctor">
            <div className={styles.title} data-qa-tag="title-call-doctor">
              <h2 data-qa-tag="heading-call-doctor">¿Cuándo debo llamar a mi profesional de la salud?</h2>
              <div className={styles.textIntroDesktop} data-qa-tag="intro-call-doctor">
                Llame inmediatamente a su profesional de la salud si tiene…
              </div>
            </div>
            <AlternativeTable
              content={SE_TABLE_3}
              className="sm alternative-new-mobile-table"
              title="llame de inmediato al médico si usted tiene:"
              data-qa-tag="table-se-3"
            />
          </RichText>
        </Container>
      </section>

      <div className={styles.questionsWrapper} data-qa-tag="questions-wrapper-side-effects">
        <ItemBreakpoint breakpoint="lg" data-qa-tag="item-breakpoint-side-effects">
        <HeroFull image={DARK_BLUE_BG} data-qa-tag="hero-full-desktop-side-effects">
          <SplitContent
            alignContent="alignCenter"
            splitAutoWidth="splitAutoWidth"
            variant="questions"
            data-design-visible="visible_vd"
            data-design-type="module"
            data-design-nori_id="Inline Content"
            data-design-module_name="¿Aún tiene preguntas?"
            data-design-module_no="07"
            data-qa-tag="split-content-desktop-side-effects"
          >
            <AjustableImage
              size="full"
              image={{ src: QUESTIONS_IMAGE, style: { width: 192, height: 192 }, alt: '' }}
              data-qa-tag="image-question-desktop"
            />
            <>
              <RichText className="quesContent" data-qa-tag="richtext-question-desktop">
                <div className="mb questionTitle" data-qa-tag="title-question-desktop">¿Aún tiene preguntas?</div>
                <div className="intro" data-qa-tag="intro-question-desktop">
                  <p>Consulte nuestras Preguntas frecuentes.</p>
                  <p>Pueden resultarle útiles.</p>
                </div>
              </RichText>
              <Button
                type="secondary4"
                href="/es-us/preguntas/"
                data-design-type="clickAction"
                data-design-category="button_vd"
                data-design-action="Button"
                data-design-label="Explore nuestras Preguntas frecuentes"
                data-design-nori_id="Inline Content"
                data-design-module_name="¿Aún tiene preguntas?"
                data-design-module_no="07"
                data-qa-tag="button-question-desktop"
              >
                Explore nuestras Preguntas frecuentes
              </Button>
            </>
          </SplitContent>
        </HeroFull>
        <HeroFull image={DARK_BLUE_BG_MOBILE} data-qa-tag="hero-full-mobile-side-effects">
          <SplitContent
            alignContent="alignCenter"
            splitAutoWidth="splitAutoWidth"
            variant="questions"
            data-design-visible="visible_vd"
            data-design-type="module"
            data-design-nori_id="Inline Content"
            data-design-module_name="¿Aún tiene preguntas?"
            data-design-module_no="07"
            data-qa-tag="split-content-mobile-side-effects"
          >
            <AjustableImage
              size="full"
              image={{ src: QUESTIONS_IMAGE_MOBILE, style: { width: 137, height: 137 }, alt: '' }}
              data-qa-tag="image-question-mobile"
            />
            <>
              <RichText className="quesContent" data-qa-tag="richtext-question-mobile">
                <div className="mb questionTitle" data-qa-tag="title-question-mobile">¿Aún tiene preguntas?</div>
                <div className="intro" data-qa-tag="intro-question-mobile">
                  <p>Consulte nuestras Preguntas frecuentes.</p>
                  <p>Pueden resultarle útiles.</p>
                </div>
              </RichText>
              <Button
                type="secondary4"
                href="/es-us/preguntas/"
                data-design-type="clickAction"
                data-design-category="button_vd"
                data-design-action="Button"
                data-design-label="Explore nuestras Preguntas Frecuentes"
                data-design-nori_id="Inline Content"
                data-design-module_name="¿Aún tiene preguntas?"
                data-design-module_no="07"
                data-qa-tag="button-question-mobile"
              >
                Explore nuestras<br />Preguntas Frecuentes
              </Button>
            </>
          </SplitContent>
        </HeroFull>
      </ItemBreakpoint>
      </div>
      </div>
    </AltLayout>
  );
}
